import type { Specimen } from "@src/packages/care/cryovault/useSpecimens";

export type EmbryoDevelopmentObservation = NonNullable<
  Specimen["dayDetails"]
>[number];

export function sortEmbryoDevelopmentObservations(
  details: Specimen["dayDetails"],
): EmbryoDevelopmentObservation[] {
  return [...(details ?? [])].sort((left, right) => left.day - right.day);
}

export function getLatestEmbryoDevelopmentObservation(
  details: Specimen["dayDetails"],
): EmbryoDevelopmentObservation | null {
  const sorted = sortEmbryoDevelopmentObservations(details);
  return sorted.at(-1) ?? null;
}

export function formatEmbryoGradeFromDayDetails(
  details: Specimen["dayDetails"],
): string | null {
  const detail = getLatestEmbryoDevelopmentObservation(details);
  if (!detail) return null;

  if (detail.gradingNumerical != null && detail.gradingAlphabetical) {
    return `${detail.gradingNumerical}${detail.gradingAlphabetical}`;
  }

  if (detail.stage && detail.icmGrade && detail.teGrade) {
    const stageExpansion: Record<string, string> = {
      early_blastocyst: "2",
      blastocyst: "3",
      full_blastocyst: "4",
      expanded_blastocyst: "5",
      hatching_blastocyst: "6",
      fully_hatched_blastocyst: "6",
    };
    const expansion = stageExpansion[detail.stage];
    if (expansion) return `${expansion}${detail.icmGrade}${detail.teGrade}`;
  }

  return null;
}
